import React from 'react';
import Bg from './components/bg';
import Engine from './components/engine';

export default function App() {
    return (
        <div>
            <Bg />
            <Engine />
        </div>
    )
}